import ClientSideValidation, { validateElement } from '@project/components/clientSideValidation';

export default class extends ClientSideValidation {
    init() {
        super.init();
        this.blur();
    }

    blur() {
        $('form input:required, form select:required, form textarea:required').on('blur', validateElement);
    }
}
